import script from "./editAssessment.vue?vue&type=script&setup=true&lang=js"
export * from "./editAssessment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__